import { createComponentElement } from "@modules/content/creators/createComponentElement";
import { useComponentData } from "@modules/content/hooks/useComponentData";
import { ContentComponent, EmptyParameters } from "@modules/content/types";
import { useGetContentProgress } from "@modules/content/hooks/useGetContentProgress";
import { defaultPageSize } from "@modules/content/helpers/content";
import { HorizontalList } from "@components/layouts/content/HorizontalList";
import React from "react";
import { HorizontalListComponent } from "./HorizontalListComponent";
import ContentComponentSelector from ".";

export interface CollectionListsContainerParameters {
  backgroundColor: string | undefined;
  backgroundColorDark: string | undefined;
  label: string | undefined;
  labelBackground: string | undefined;
  labelBackgroundDark: string | undefined;
  labelTextColor: string | undefined;
  labelTextColorDark: string | undefined;
}

const Component = createComponentElement((props, ref) => {
  const {
    getParameterValues,
    getItemsParameterValues,
    contents,
    content,
    isLoading,
    isLoadingMore,
    componentData,
    uniqueId,
    getMore,
    refresh,
    meta: { hasNextPage },
  } = useComponentData<CollectionListsContainerParameters>(
    {
      ...props,
      // pageNumber: 1,
      // pageSize: defaultPageSize,
    },
    ref
  );

  const {
    backgroundColor,
    backgroundColorDark,
    label,
    labelBackground,
    labelBackgroundDark,
    labelTextColor,
    labelTextColorDark,
  } = getParameterValues([
    "backgroundColor",
    "backgroundColorDark",
    "label",
    "labelBackground",
    "labelBackgroundDark",
    "labelTextColor",
    "labelTextColorDark",
  ]);

  return (
    <>
      {contents?.map((ctn) => {
        return (
          <div key={ctn.id}>
            <ContentComponentSelector
              context={ctn}
              component={props.component?.itemTemplate}
              identifier={props.component?.itemTemplate?.type || ""}
              componentRef={null}
              onItemPress={props.onItemPress}
            />
          </div>
        );
      })}
    </>
  );
});

export const CollectionListsContainerComponent: ContentComponent = {
  identifier: "COM:COLLECTION:LIST:CONTAINER",
  component: Component,
};
